import React, { useState, useEffect } from "react";
import { CampaignCard } from "../../components";
import { CampaignHeaderCard } from "../../components/";
import { CampaignViewEdit, AddUserToCampaign } from "../../components/index";
import { useSelector } from "react-redux";
import { handleApi } from "../../utils/authentication";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import LoadingSpinner from "../../components/client/LoadingSpinner";

const ClientCampaigns = () => {
  const [activeTab, setActiveTab] = useState("all_campaigns");
  const [show, setShow] = useState(false);
  const [campaignList, setCampaignList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector((state) => state?.user);
  const [campaign_id, setCampaignId] = useState();
  const [userList, setUserList] = useState([]);
  const [program, setProgram] = useState({});

  const [campaignsCount, setCampaignsCount] = useState(0);
  const { client_id } = useParams();

  //get campaign list

  const getCampaignList = async () => {
    try {
      setIsLoading(true);
      let method = "POST";
      let headers = {};
      let formData = new FormData();
      formData.append("client_id", client_id);
      formData.append("role_id", user?.role_id);

      let result = await handleApi(`campaign_list`, method, headers, formData);
      if (result?.success) {
        setCampaignList(result?.data?.internal_campaign_list);
        setCampaignsCount(result?.data?.total_campaign_count);
      } else {
        // toast.error(result?.error?.error_message ? result?.error?.error_message : "Failed to fetch campaign list", {
        //     position: "top-right",
        //     autoClose: 5000,
        //     hideProgressBar: false,
        //     closeOnClick: true,
        //     pauseOnHover: true,
        //     draggable: true,
        //     progress: undefined,
        //     theme: "light",
        // });
      }
    } catch (e) {
      console.log(e);
      toast.error(e?.message ? e?.message : "Failed to fetch campaign list", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setIsLoading(false);
    }
  };
  const getUsertList = async () => {
    try {
      setIsLoading(true);
      let method = "POST";
      let headers = {};
      let formData = new FormData();
      formData.append("client_id", client_id);

      let result = await handleApi(`user_list`, method, headers, formData);
      if (result?.success) {
        setUserList(result?.data?.user_list);
      } else {
        toast.error(
          result?.error?.error_message
            ? result?.error?.error_message
            : "Users not found",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          },
        );
      }
    } catch (e) {
      console.log(e);
      toast.error(e?.message ? e?.message : "Users not found", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getCampaignList();
  }, [client_id]);

  // useEffect(()=>{

  //   getCampaignList()
  //   if(user?.program_id)
  //   {
  //     setProgram({
  //       program_id:user?.program_id,
  //       program_name:user?.program_name
  //     })

  //   }

  // },[user?.program_id,show])
  useEffect(() => {
    getUsertList();
  }, []);

  return (
    <div className="row  d-flex w-100  m-0 ">
      <div className="row campaign_header_tab d-flex align-items-center  mb-3 ">
        <div className="col-lg-10 col-md-12 row ">
          <div className="col-lg-2 col-md-3  ">
            <span onClick={() => setActiveTab("all_campaigns")}>
              <p
                className={`mb-0 ${activeTab === "all_campaigns" && "campaign_header_tab_active"}`}
              >
                All Campaigns ({campaignsCount})
              </p>
              {activeTab === "all_campaigns" && (
                <div style={{ border: "solid 1px #7f56d9" }}> </div>
              )}
            </span>
          </div>
          <div className="col-lg-2 col-md-3 text-center">
            <span onClick={() => setActiveTab("mine_campaigns")}>
              <p
                className={`mb-0 ${activeTab === "mine_campaigns" && "campaign_header_tab_active"}`}
              >
                Mine (0)
              </p>
              {activeTab === "mine_campaigns" && (
                <div style={{ border: "solid 1px #7f56d9" }}> </div>
              )}
            </span>
          </div>
          <div className="col-lg-2 col-md-3 text-center ">
            <span onClick={() => setActiveTab("completed_campaigns")}>
              <p
                className={`mb-0 ${activeTab === "completed_campaigns" && "campaign_header_tab_active"}`}
              >
                Completed (0)
              </p>
              {activeTab === "completed_campaigns" && (
                <div style={{ border: "solid 1px #7f56d9" }}> </div>
              )}
            </span>
          </div>
          <div className="col-lg-2 col-md-3 text-center">
            <span onClick={() => setActiveTab("archived_campaigns")}>
              <p
                className={`mb-0 ${activeTab === "archived_campaigns" && "campaign_header_tab_active"}`}
              >
                Archived (0)
              </p>
              {activeTab === "archived_campaigns" && (
                <div style={{ border: "solid 1px #7f56d9" }}> </div>
              )}
            </span>
          </div>

          <div className="col-lg-4 col-md-4"></div>
        </div>
        <div className="col-lg-2 col-md-4 d-flex justify-content-lg-end ">
          {(user?.role_id === 2 || user?.role_id === 1) && (
            <button
              style={{ marginRight: "-7.5vw" }}
              onClick={() => {
                setShow(true);
              }}
              className="btn btn-md  rounded-pill  btn-primary nav_export_stats_btn"
            >
              Create Campaign
            </button>
          )}
        </div>
      </div>
      {/* if program_id is set */}
      {user?.program_id && (
        <div className="card campaign_card">
          <div className="d-flex justify-content-between align-items-center  campaign_card_heading ">
            <p className="mb-0">{user?.program_name}</p>
            <p className="mb-0">
              {" "}
              {campaignList?.length > 0 ? campaignList?.length : 0} ATTACHED
              CAMPAIGNS{" "}
            </p>
          </div>
          {!isLoading &&
            campaignList &&
            campaignList.length > 0 &&
            campaignList.map((campaign) => {
              return (
                <CampaignCard
                  setProgramDetails={() => {}}
                  userList={userList}
                  key={campaign?.campaign_id}
                  campaign={campaign}
                  setCampaignId={setCampaignId}
                  setShow={setShow}
                />
              );
            })}
          {isLoading && (
            <div className="position-absolute top-50 end-50">
              <LoadingSpinner />
            </div>
          )}
          {!isLoading && campaignList && campaignList.length === 0 && (
            <div className=" position-absolute top-50 end-50 ">
              <div className=" w-full " role="status">
                <h5>No Campaigns found</h5>
              </div>
            </div>
          )}
        </div>
      )}
      {/* if program id is not set fetch all campaigns using client_id */}

      {!user?.program_id &&
        !isLoading &&
        campaignList &&
        campaignList.length > 0 &&
        campaignList.map((campaign) => {
          return (
            <div
              className="card campaign_card d-none "
              key={campaign?.program_id}
            >
              <div className="d-flex justify-content-between align-items-center  campaign_card_heading ">
                <p className="mb-0">{campaign?.program_name}</p>
                <p className="mb-0">
                  {" "}
                  {campaign?.campaign_list?.length > 0
                    ? campaign?.campaign_list?.length
                    : 0}{" "}
                  ATTACHED CAMPAIGNS{" "}
                </p>
              </div>
              {campaign?.campaign_list &&
                campaign?.campaign_list?.length > 0 &&
                campaign?.campaign_list.map((campaign_details) => {
                  return (
                    <CampaignCard
                      setProgramDetails={() => {
                        setProgram({
                          program_name: campaign?.program_name,
                          program_id: campaign?.program_id,
                        });
                      }}
                      userList={userList}
                      key={campaign_details?.campaign_id}
                      campaign={campaign_details}
                      setCampaignId={setCampaignId}
                      setShow={setShow}
                    />
                  );
                })}
            </div>
          );
        })}

      {!user?.program_id &&
        !isLoading &&
        campaignList &&
        campaignList.length > 0 && (
          <div
            className="accordion  custom-accordion px-0"
            id="accordionExample"
          >
            {campaignList.map((campaign, index) => (
              <div className="accordion-item" key={campaign?.program_id}>
                <h2 className="accordion-header " id={`heading${index}`}>
                  <button
                    className={`accordion-button ${index !== 0 ? "collapsed" : ""} campaign_card_heading  d-flex justify-content-between align-items-center`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse${index}`}
                    aria-expanded={index === 0 ? "true" : "false"}
                    aria-controls={`collapse${index}`}
                  >
                    <p className="mb-0">{campaign?.program_name}</p>
                    <p
                      className="mb-0  "
                      style={{ position: "absolute", right: "3.5rem" }}
                    >
                      {campaign?.campaign_list?.length > 0 &&
                      campaign?.campaign_list[0]?.campaign_id
                        ? campaign?.campaign_list?.length
                        : 0}{" "}
                      ATTACHED CAMPAIGNS
                    </p>
                  </button>
                </h2>
                <div
                  id={`collapse${index}`}
                  className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
                  aria-labelledby={`heading${index}`}
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    {campaign?.campaign_list &&
                      campaign?.campaign_list.length > 0 &&
                      campaign?.campaign_list.map((campaign_details) => (
                        <CampaignCard
                          setProgramDetails={() => {
                            setProgram({
                              program_name: campaign?.program_name,
                              program_id: campaign?.program_id,
                            });
                          }}
                          userList={userList}
                          key={campaign_details?.campaign_id}
                          campaign={campaign_details}
                          setCampaignId={setCampaignId}
                          setShow={setShow}
                        />
                      ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      {!isLoading && campaignList && campaignList.length <= 0 && (
        <div className="card campaign_card">
          <div className="d-flex justify-content-between align-items-center  campaign_card_heading ">
            <p className="mb-0">Campaigns List</p>
          </div>
          {!isLoading && campaignList && campaignList.length === 0 && (
            <div style={{ position: "absolute", left: "37%", top: "50%" }}>
              <div className=" w-full " role="status">
                <h5>No Campaigns To Display</h5>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ClientCampaigns;
